import styles from "./AssessmentProgressReport.module.css";
import SearchBar from "../../../components/SearchBar/SearchBar";
import Dropdown from "../../../components/Dropdown/Dropdown";
import Dynamic from "../../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../../components/LogoWithName/LogoWithName";
import Action from "../../../components/Action/Action";
import { FiInfo } from "react-icons/fi";
import IconAndName from "../../../components/IconAndName/IconAndName";


const data = [
  { _id: "1", name: "John Jacob", template: "No progress" },
  { _id: "2", name: "John Jacob", template: "No progress" },
  { _id: "3", name: "John Jacob", template: "No progress" },
  { _id: "4", name: "John Jacob", template: "No progress" },
];
  
const downloadTableData = () => {
  const csvContent =
    "data:text/csv;charset=utf-8," +
    ["Student Name,Template"]
      .concat(data.map(() => "John Jacob,No progress")) // Customize based on real data if needed
      .join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "assessment_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  

function AssessmentProgressReport() {
    const [selectedRoom, setSelectedRoom] = useState("");
    const [selectedGroup, setSelectedGroup] = useState("");
    const [selectedTemplate, setSelectedTemplate] = useState("");

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const getColumnData = (data) => {
    return data.map((item) => ({
      studentName: (
        <LogoWithName
          name={item.name}
          textColor="var(--Primary_Color)"
          bgColor="var(--Utility_Color1)"
        />
      ),
      template: (
        <span style={{ color: "var(--Grey_Color)" }}>{item.template}</span>
      ),
    }));
  };
  
  

  const displayData = getColumnData(data);

  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Template", accessor: "template" },
  ];
  
  
  return (
    <div className={styles.headerContainer}>
      <div className={styles.infoLine}>
        <span>
          <span style={{ color: "var(--Grey_Color)" }}>Development Area: </span>
          <span style={{ color: "var(--Primary_Color)", fontWeight: 500 }}>
            Creative Arts and Expressions
          </span>
        </span>
      </div>
      <div className={styles.totalstudentcard}>
        <div className={styles.header}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.dropdown}>
            <Dropdown
              label="Room"
              options={["Room 1", "Room 2"]}
              value={selectedRoom}
              onChange={setSelectedRoom}
            />
            <Dropdown
              label="Groups"
              options={["Group A", "Group B"]}
              value={selectedGroup}
              onChange={setSelectedGroup}
            />
            <Dropdown
              label="Assessment Template"
              options={["Template 1", "Template 2"]}
              value={selectedTemplate}
              onChange={setSelectedTemplate}
            />
            <IconAndName  title="Download" onClick={downloadTableData} />
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default AssessmentProgressReport;
